var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MasterCategoriesItem"},[_c('h3',{staticClass:"MasterCategoriesItem__name",class:{
			'MasterCategoriesItem__name--active': _vm.item.id === _vm.selectedMasterCategory.id
		}},[_vm._v(" "+_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }